import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DFE8F9",
      d: "M10.62 5.5c1.23-.07 2.52.05 3.76 0 .2 0 .4.11.53.27l.67 1.24.04.03h9.08c1.74.1 3.16 1.51 3.3 3.24v16.45c-.13 1.71-1.53 3.11-3.24 3.24H10.53c-1.71-.14-3.1-1.54-3.23-3.24V8.77C7.42 7 8.86 5.6 10.62 5.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6B92E4",
      d: "M26.41 10.51v15.58c-.09 1.19-1.06 2.17-2.25 2.25H8.09c-1.16-.1-2.1-1.03-2.21-2.19V5.68c.11-1.21 1.13-2.16 2.34-2.21h3.66l3.62 6.72c.1.13.38.32.55.32h10.37z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M5 25.22V6.72a3.746 3.746 0 0 1 3.75-3.75h3.75l.102.007a.75.75 0 0 1 .558.387l3.287 6.106h9.803a.75.75 0 0 1 .75.75v15a3.746 3.746 0 0 1-3.75 3.75H8.75A3.746 3.746 0 0 1 5 25.22m1.5 0a2.246 2.246 0 0 0 2.25 2.25h14.5a2.246 2.246 0 0 0 2.25-2.25V10.97H16a.75.75 0 0 1-.66-.395L12.053 4.47H8.75A2.246 2.246 0 0 0 6.5 6.72z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M25.5 14.1V8.35a2.246 2.246 0 0 0-2.25-2.25h-9.5a.75.75 0 0 1 0-1.5h9.5A3.746 3.746 0 0 1 27 8.35v5.75a.75.75 0 0 1-1.5 0"
    }, null, -1)
  ]))]))
}
export default { render: render }